import React, { useEffect, useState } from 'react';
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import './TrancheReports.css';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import { getTrancheReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import { downloadReport, downloadReportByDateRange, resetFilters } from '../../../utils/reportUtils';
import DownloadReport from '../DownloadReport';
import { TRANCHE_STATUS } from '../../../utils/mappings';
import FilterModal from '../FilterModal/FilterModal';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import { isAuthorised } from '../../../utils/common';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

const TrancheReports = () => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    const { trancheReport, pagination, officerProfile } = useSelector((store) => {
        return {
            trancheReport: store.ReportsReducer.trancheReport.data,
            pagination: store.ReportsReducer.trancheReport.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);

    const storedFilters = JSON.parse(sessionStorage.getItem('trancheFilters')) || {};
    
    const [trancheFilters, setTrancheFilters] = useState({
        customer_name: storedFilters?.customer_name || "",
        customer_id: storedFilters?.customer_id || "",
        lms_id: storedFilters?.lms_id || "",
        branch: storedFilters?.branch || "",
        tranche_id: storedFilters?.tranche_id || "",
        staff: storedFilters?.staff || "",
        supplier_gst: storedFilters?.supplier_gst || "",
        client_gst: storedFilters?.client_gst || "",
        status: storedFilters?.status || "",
        supplier: storedFilters?.supplier || "",
        sector: storedFilters?.sector || "",
        sub_sector: storedFilters?.sub_sector || "",
        from_date: storedFilters?.from_date || "",
        to_date: storedFilters?.to_date || "",
        global_search: storedFilters?.global_search || ""
    });

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const leads = [];

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [dateRange, setDateRange] = useState([
        trancheFilters?.from_date ? new Date(trancheFilters.from_date) : null,
        trancheFilters?.to_date ? new Date(trancheFilters.to_date) : null,
    ]);

    const [startDate, endDate] = dateRange;

    useEffect(() => {
        dispatch(getTrancheReport(currentPage, limit, trancheFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('trancheFilters', JSON.stringify(trancheFilters));
    // }, [dispatch, limit, currentPage, trancheFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("trancheFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const updatedFilters = {
            ...trancheFilters,
            from_date: formatDate(start),
            to_date: formatDate(end),
        };

        setTrancheFilters(updatedFilters);
        sessionStorage.setItem("trancheFilters", JSON.stringify(updatedFilters));
    };
    
    const handleFilterChange = (e) => {
        let {name, value} = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...trancheFilters,
            [name]: value
        };

        setTrancheFilters(updatedFilters);
        sessionStorage.setItem("trancheFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
        <div className="reportsDashboardContainer">
            <div className="reportsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                            <UserProfileDropdown />
                        </div>
                    </div>

                    <div className="pageContentWrapper">
                        <div className="pageHeaderSection">
                        <Breadcrumb items={[
                            { label: 'Admin' },
                            { label: 'Reports', onClick: () => navigate('/reports') },
                            { label: 'Tranche' }
                        ]} />

                        <div className="pageActions">
                            <h2>Tranche</h2>
                        </div>
                    </div>

                    <div className="searchControlSection">
    <div className="searchGroup">
        {isAuthorised(
            officerProfile,
            REPORTS_COMPONENTS['tranche_search']
        ) && <div className="tableSearchBar">
            <input 
                // type="text" 
                type="search" 
                placeholder="Search" 
                name="global_search"
                value={trancheFilters?.global_search} 
                onChange={handleFilterChange}
                onInput={(e) => {
                    if (e.target.value === "") {
                        let updatedFilters = {
                            ...trancheFilters,
                            global_search: e.target.value
                        }

                        setTrancheFilters(updatedFilters)

                        dispatch(getTrancheReport(1, limit, updatedFilters));
                        handlePageChange(1);
                    }
                }}
            />
            {/* <FontAwesomeIcon icon={faSearch} /> */}
        </div>}
        <div className="searchActionButtons">
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['tranche_search']
            ) && <button 
                className="searchButton"
                onClick={() => {
                    dispatch(getTrancheReport(1, limit, trancheFilters, null));
                }}
            >
                 <FontAwesomeIcon icon={faSearch} />
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['tranche_download']
            ) && <button 
                className="downloadButton"
                // onClick={() => downloadReportByDateRange("tranche", trancheFilters?.from_date, trancheFilters?.to_date)}
                // onClick={() => setShowDownloadModal(true)}
                onClick={() => {
                    downloadReport("tranche", trancheFilters, setIsDownloading);
                }}
                disabled={isDownloading}
            >
                {isDownloading ? (
                    <>
                        <span className="buttonSpinner"></span>
                        Downloading...
                    </>
                ) : (
                    <>
                        Download
                    </>
                )}
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['tranche_filters']
            ) && <button 
                className="filterButton"
                onClick={() => setShowFilterModal(true)}
            >
                <FunnelIconSvg fillColor={"black"}/>
            </button>}
        </div>
    </div>
</div>

                    {
                        showFilterModal && (
                            <FilterModal 
                                reportTitle={"tranche"}
                                filters={trancheFilters}
                                setFilters={setTrancheFilters}
                                resetFilters={() => {
                                    let resettedFilters = resetFilters(trancheFilters);

                                    setTrancheFilters(resettedFilters);
                                    dispatch(getTrancheReport(1, limit, resettedFilters, null));
                                    handlePageChange(1);
                                    setShowFilterModal(false);
                                    sessionStorage.setItem("trancheFilters", JSON.stringify(resettedFilters));
                                    return resettedFilters;
                                }}
                                handleApplyFilters={(finalFilters) => {
                                    handlePageChange(1);
                                    dispatch(getTrancheReport(1, limit, finalFilters, null));
                                    setShowFilterModal(false);
                                }}
                                onClose={() => {
                                    setShowFilterModal(false)
                                }}
                            />
                        )
                    }

                    <div className="tableCard">
                        <main className="">
                            <div className="reportsTableContainer">
                                <table className="applications-table" style={{ overflowX: "auto" }}>
                                <thead>
                                    <tr>
                                        {/* <th>Application ID</th> */}
                                        <th>Branch</th>
                                        <th>Branch Code</th>
                                        <th>Customer Name</th>
                                        <th>Customer ID</th>
                                        <th>Loan ID</th>
                                        <th>Tranche ID</th>
                                        <th>RO - Assigned</th>
                                        <th>Amount Sanctioned</th>
                                        <th>Sanctioned By</th>
                                        <th>Loan Creation Date</th>
                                        <th>Tranche Amount</th>
                                        <th>Status</th>
                                        <th>Supplier Name</th>
                                        <th>Supplier GST</th>
                                        <th>Customer Mobile No.</th>
                                        <th>RO - Assigned Contact No.</th>
                                        <th>Tranche Requested Date</th>
                                        <th>Tranche Approved Date</th>
                                        <th>Tranche Rejected Date</th>
                                        <th>Tranche DB Date</th>
                                        <th>Tranche Closure Date</th>
                                        <th>Tranche Valid Up To</th>
                                        <th>OD Status</th>
                                        <th>DPD</th>
                                        <th>Tranche O/S Amount</th>
                                        <th>Limit Availability</th>
                                        {/* <th>Sequence No.</th> */}
                                        <th>Last Due Amount</th>
                                        <th>Last Paid Amount</th>
                                        <th>Last Due Date</th>
                                        <th>Last Paid Date</th>
                                        <th>Next Due Amount</th>
                                        <th>Next Due Date</th>
                                        <th>Next Demand Amount(Inc. OD)</th>
                                    </tr>

                                    {/* <tr className="filter-row">
                                        <td>
                                            <input
                                                type="text"
                                                name="branch"
                                                value={trancheFilters?.branch || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_name"
                                                value={trancheFilters?.customer_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_id"
                                                value={trancheFilters?.customer_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="lms_id"
                                                value={trancheFilters?.lms_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="tranche_id"
                                                value={trancheFilters?.tranche_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="staff"
                                                value={trancheFilters?.staff || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="status"
                                                value={trancheFilters?.status || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />

                                            <select 
                                                name="status"
                                                className="column-filter status-filter"
                                                value={trancheFilters?.status || ""}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">All Status</option>
                                                {
                                                Object.entries(TRANCHE_STATUS).map(([key, label]) => (
                                                    <option key={key} value={label}>
                                                    {label}
                                                    </option>
                                                ))
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="supplier"
                                                value={trancheFilters?.supplier || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="supplier_gst"
                                                value={trancheFilters?.supplier_gst || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                </thead>
                                <tbody>
                                    {
                                        trancheReport?.length === 0 ? 
                                        <tr>
                                            <td colSpan={12} className="no-data-cell">
                                                No records found
                                            </td>
                                        </tr> :
                                        trancheReport?.map((tranche, index) => (
                                            <tr key={index}>
                                                {/* <td>{tranche?.application_id}</td> */}
                                                <td>{tranche?.branch_name}</td>
                                                <td>{tranche?.branch_code}</td>
                                                <td>{tranche?.customer_name}</td>
                                                <td>{tranche?.customer_id}</td>
                                                <td>{tranche?.loan_id}</td>
                                                <td>{tranche?.tranche_id}</td>
                                                <td>{tranche?.ro_assigned}</td>
                                                <td>{tranche?.amount_sanctioned}</td>
                                                <td>{tranche?.sanctioned_by}</td>
                                                <td>{tranche?.loan_creation_date}</td>
                                                <td>{tranche?.tranche_amount}</td>
                                                <td>{tranche?.tranche_status}</td>
                                                <td>{tranche?.supplier_name}</td>
                                                <td>{tranche?.supplier_gst}</td>
                                                <td>{tranche?.customer_mobile_no}</td>
                                                <td>{tranche?.ro_assigned_contact_no}</td>
                                                <td>{tranche?.tranche_req_date}</td>
                                                <td>{tranche?.tranche_approved_date}</td>
                                                <td>{tranche?.tranche_rejected_date}</td>
                                                <td>{tranche?.tranche_disbursed_date}</td>
                                                <td>{tranche?.tranche_closure_date}</td>
                                                <td>{tranche?.tenure}</td>
                                                <td>{tranche?.od_status}</td>
                                                <td>{tranche?.dpd}</td>
                                                <td>{tranche?.tranche_os_amount}</td>
                                                <td>{tranche?.limit_available}</td>
                                                {/* <td>{tranche?.}</td> */}
                                                <td>{tranche?.last_due_amount}</td>
                                                <td>{tranche?.last_paid_amount}</td>
                                                <td>{tranche?.last_due_date}</td>
                                                <td>{tranche?.last_paid_date}</td>
                                                <td>{tranche?.next_due_amount}</td>
                                                <td>{tranche?.next_due_date}</td>
                                                <td>{tranche?.next_demand_amount_inc_od}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        {trancheReport?.length > 0 && <div className="paginationControls">
                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>}
                        </main>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        {
            showDownloadModal && (
                <DownloadReport 
                    isOpen={showDownloadModal}
                    onClose={() => setShowDownloadModal(false)}
                    reportTitle={"tranche"}
                />
            )
        }
        </>
    )
}

export default TrancheReports